module.exports = __webpack_public_path__ + "img/somalia.8f540c0d.png";